import Box from '@mui/material/Box';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ChoiceField from '../common/ChoiceField';

const PatientSchedulingSearchMethodForm = ({
  onSubmit,
  stepNum = 0,
  subtitle = 'Choose your preferred search',
  omitTextSearchMethod = false,
}) => {
  return (
    <Stack spacing={1} alignItems='left'>
      <Typography variant='h2'>How would you like to search?</Typography>
      <Typography>{subtitle}</Typography>
      <Box style={{width: '100%'}}>
        <ChoiceField
          choiceStyle='card'
          onChange={(e, val) => onSubmit(e, val)}
          useColoredBackground={true}
          layout='row'
          equalHeightCards={true}
          options={[
            {
              label: 'I Know a Provider',
              value: 'KNOWN_PROVIDER',
              Icon: PersonSearchIcon,
              color: 'secondary',
              description: 'You can enter a provider name, zip, or address.',
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
            {
              label: 'Find Providers Near Me',
              value: 'BY_PROVIDER',
              Icon: SearchIcon,
              color: 'purple',
              description: 'Enter your address to find providers near you and filter by specialty.',
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
            {
              label: 'Find By Availability',
              value: 'BY_AVAILABILITY',
              Icon: AccessTimeIcon,
              color: 'primary',
              description: 'Browse providers with open time slots that match your schedule',
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          ].filter((option, i) => 
            omitTextSearchMethod && i === 0 ? false : true
          )}
        />
      </Box>
    </Stack>
  );
};

export default PatientSchedulingSearchMethodForm;
